import { IconPlus } from "@tabler/icons-react";

const CreateRatePlanButton = ({ openDrawer }) => {
  return (
    <button
      onClick={openDrawer}
      className="
        inline-flex items-center gap-2
        px-5 py-2.5
        bg-[#3A9D23] hover:bg-[#33891E]
        text-white text-sm font-semibold
        rounded-xl
        transition-all duration-200
        active:scale-[0.97]
        shadow-sm hover:shadow-md
      "
    >
      <IconPlus size={16} strokeWidth={2.5} />
      Créer un tarif
    </button>
  );
};

export default CreateRatePlanButton;